export const RESET_STATE = 'RESET_STATE';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN';
export const SET_IN_REGISTRATION_PROCESS = 'SET_IN_REGISTRATION_PROCESS';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';
export const SET_PREDEFINED_SEASON = 'SET_PREDEFINED_SEASON';

// NAVIGATION DRAWER
export const SHOW_NAVIGATION_DRAWER = 'SHOW_NAVIGATION_DRAWER';
export const HIDE_NAVIGATION_DRAWER = 'HIDE_NAVIGATION_DRAWER';
export const TOGGLE_NAVIGATION_DRAWER = 'TOGGLE_NAVIGATION_DRAWER';

// FETCH_USER_PROFILE
export const FETCH_USER_PROFILE_PENDING = 'FETCH_USER_PROFILE_PENDING';
export const FETCH_USER_PROFILE_FULFILLED = 'FETCH_USER_PROFILE_FULFILLED';
export const FETCH_USER_PROFILE_ERROR = 'FETCH_USER_PROFILE_ERROR';

// UPDATE_USER_PROFILE
export const UPDATE_USER_PROFILE_PENDING = 'UPDATE_USER_PROFILE_PENDING';
export const UPDATE_USER_PROFILE_FULFILLED = 'UPDATE_USER_PROFILE_FULFILLED';
export const UPDATE_USER_PROFILE_ERROR = 'UPDATE_USER_PROFILE_ERROR';

// FETCH_FAVORITES
export const FETCH_FAVORITES_PENDING = 'FETCH_FAVORITES_PENDING';
export const FETCH_FAVORITES_FULFILLED = 'FETCH_FAVORITES_FULFILLED';
export const FETCH_FAVORITES_ERROR = 'FETCH_FAVORITES_ERROR';

// ADD_FAVORITE
export const ADD_FAVORITE_PENDING = 'ADD_FAVORITE_PENDING';
export const ADD_FAVORITE_FULFILLED = 'ADD_FAVORITE_FULFILLED';
export const ADD_FAVORITE_ERROR = 'ADD_FAVORITE_ERROR';

// REMOVE_FAVORITE
export const REMOVE_FAVORITE_PENDING = 'REMOVE_FAVORITE_PENDING';
export const REMOVE_FAVORITE_FULFILLED = 'REMOVE_FAVORITE_FULFILLED';
export const REMOVE_FAVORITE_ERROR = 'REMOVE_FAVORITE_ERROR';

// FETCH_NOTIFICATIONS
export const FETCH_NOTIFICATIONS_PENDING = 'FETCH_NOTIFICATIONS_PENDING';
export const FETCH_NOTIFICATIONS_FULFILLED = 'FETCH_NOTIFICATIONS_FULFILLED';
export const FETCH_NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR';

// UPDATE_NOTIFICATION
export const UPDATE_NOTIFICATION_PENDING = 'UPDATE_NOTIFICATION_PENDING';
export const UPDATE_NOTIFICATION_SUCCESFUL = 'UPDATE_NOTIFICATION_SUCCESFUL';
export const UPDATE_NOTIFICATION_ERROR = 'UPDATE_NOTIFICATION_ERROR';

// UPDATE_ALL_NOTIFICATIONS
export const UPDATE_ALL_NOTIFICATIONS_READ_PENDING = 'UPDATE_ALL_NOTIFICATIONS_READ_PENDING';
export const UPDATE_ALL_NOTIFICATIONS_READ_FULFILLED = 'UPDATE_ALL_NOTIFICATIONS_READ_FULFILLED';
export const UPDATE_ALL_NOTIFICATIONS_READ_ERROR = 'UPDATE_ALL_NOTIFICATIONS_READ_ERROR';

// SEND_CONTACT_FORM
export const SEND_CONTACT_FORM_PENDING = 'SEND_CONTACT_FORM_PENDING';
export const SEND_CONTACT_FORM_FULFILLED = 'SEND_CONTACT_FORM_FULFILLED';
export const SEND_CONTACT_FORM_ERROR = 'SEND_CONTACT_FORM_ERROR';

// REGISTER_NEWSLETTER
export const REGISTER_NEWSLETTER_PENDING = 'REGISTER_NEWSLETTER_PENDING';
export const REGISTER_NEWSLETTER_FULFILLED = 'REGISTER_NEWSLETTER_FULFILLED';
export const REGISTER_NEWSLETTER_ERROR = 'REGISTER_NEWSLETTER_ERROR';

// SEND_PASSWORD_RESET_MAIL
export const SEND_PASSWORD_RESET_MAIL_PENDING = 'SEND_PASSWORD_RESET_MAIL_PENDING';
export const SEND_PASSWORD_RESET_MAIL_FULFILLED = 'SEND_PASSWORD_RESET_MAIL_FULFILLED';
export const SEND_PASSWORD_RESET_MAIL_ERROR = 'SEND_PASSWORD_RESET_MAIL_ERROR';

// SEND_PASSWORD_RESET
export const SEND_PASSWORD_RESET_PENDING = 'SEND_PASSWORD_RESET_PENDING';
export const SEND_PASSWORD_RESET_FULFILLED = 'SEND_PASSWORD_RESET_FULFILLED';
export const SEND_PASSWORD_RESET_ERROR = 'SEND_PASSWORD_RESET_ERROR';
